import { SELECT_WATER, SELECT_EQUIPMENT, VIEW_CART } from './constants';

export const steps = {
  [SELECT_WATER]: {
    buttonText: 'Select Water',
    nextButtonText: 'SELECT EQUIPMENT',
    nextStepText: 'Step 2: Select your equipment.',
    itemCategory: 'LargeBottle',
    subtitle: 'Step 1:',
    title: 'Shop all water types',
    primaryNote: 'You are on a 2 week delivery cycle',
    notes: [
      'Please make sure to select the amount of water you will need for a 2-week period until your next delivery.',
    ],
    showSkipButton: false,
    skipButtonText: null,
    skipButtonLabel: null,
    skipButtonColor: null,
    step: 1,
    costco: {
      buttonText: 'Select Water',
      nextButtonText: 'SELECT EQUIPMENT',
      nextStepText: 'Step 2: Select your equipment.',
      itemCategory: 'Large Bottle',
      subtitle: 'Step 1:',
      title: 'Shop all water types',
      primaryNote: 'You are on a 2 week delivery cycle*',
      notes: [
        "Be sure to select the correct amount of water you'll need until your next delivery.",
      ],
      showSkipButton: false,
      skipButtonText: null,
      skipButtonLabel: null,
      skipButtonColor: null,
      step: 1,
    },
  },
  [SELECT_EQUIPMENT]: {
    buttonText: 'Select Equipment',
    nextButtonText: 'Review Cart',
    nextStepText: 'Step 2: Select your equipment.',
    itemCategory: 'Equipment',
    subtitle: 'Step 2',
    title: 'Select your cooler rental',
    notes: [
      'We have state-of-the-art water coolers to keep it flowing at home and in the office. Subject to availability:',
    ],
    showSkipButton: true,
    skipButtonText: 'Already have an equipment?',
    skipButtonLabel: 'Skip this step',
    skipButtonColor: 'Blue',
    step: 2,
    costco: {
      buttonText: 'Add Equipment',
      nextButtonText: 'Review Cart',
      title: 'Add your cooler rental',
      notes: [
        'Our state-of-the-art water cooler will keep your entire family or office refreshed.',
      ],
    },
  },
  [VIEW_CART]: {
    buttonText: 'View Cart',
    subtitle: 'Step 3',
    title: null,
    notes: [],
    content: null,
    step: 3,
    costco: {
      buttonText: 'View Cart',
      notes: [],
    },
  },
};
